import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPasskeyPage } from "./pages/RegisterPasskeyPage";
import { AppRedirectPage } from "./pages/AppRedirectPage";
import { HomePage, UsersPage, UserDetailPage, RolesPage, RoleDetailPage, ClientsPage, ClientDetailPage, LoansPage, LoanDetailPage, ProfilePage, SettingsThemePage, SettingsCompanyPage, SettingsCompanyDetailPage, OnboardingPage, BillingDashboardPage, BillingTenantsPage, BillingTenantDetailPage, SettingsIntegrationsPage, DocumentsReviewPage, PipelinePage, LeadsFunnelPage, AuditPage, CampaignsPage, ChargePlanWizardPage, PasskeysPage, BaixasPage } from "./pages/dashboard";
import { GestorLoginPage } from "./pages/GestorPage";
import { GestorDevicesPage } from "./pages/gestor/GestorDevicesPage";
import { SignatureUsagePage } from "./pages/gestor/SignatureUsagePage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { DashboardLayout } from "./components/DashboardLayout";
import { GestorLayout } from "./components/GestorLayout";
import { useAuth } from "./contexts/AuthContext";

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register-passkey" element={<RegisterPasskeyPage />} />
      <Route path="/app/:slug" element={<AppRedirectPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />

      {/* Protected dashboard routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <HomePage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/usuarios"
        element={
          <ProtectedRoute permission="users.view">
            <DashboardLayout>
              <UsersPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/usuarios/:id"
        element={
          <ProtectedRoute permission="users.view">
            <DashboardLayout>
              <UserDetailPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/perfis"
        element={
          <ProtectedRoute permission="roles.view">
            <DashboardLayout>
              <RolesPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/perfis/:id"
        element={
          <ProtectedRoute permission="roles.view">
            <DashboardLayout>
              <RoleDetailPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/clientes"
        element={
          <ProtectedRoute permission="clientes:listar">
            <DashboardLayout>
              <ClientsPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/clientes/:id"
        element={
          <ProtectedRoute permission="clientes:visualizar">
            <DashboardLayout>
              <ClientDetailPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/emprestimos"
        element={
          <ProtectedRoute permission="emprestimos:listar">
            <DashboardLayout>
              <LoansPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/emprestimos/baixas"
        element={
          <ProtectedRoute permission="parcelas:listar">
            <DashboardLayout>
              <BaixasPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/emprestimos/:id"
        element={
          <ProtectedRoute permission="emprestimos:visualizar">
            <DashboardLayout>
              <LoanDetailPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/perfil"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <ProfilePage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/chaves"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <PasskeysPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/configuracoes/tema"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <SettingsThemePage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/configuracoes/empresa"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <SettingsCompanyPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/configuracoes/empresa/editar"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <SettingsCompanyDetailPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      {/* Rotas /configuracoes/emprestimos, /renovacao e /feriados removidas —
          configuracoes agora sao per-campanha no wizard de plano de cobranca. */}

      <Route
        path="/dashboard/configuracoes/integracoes"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <SettingsIntegrationsPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/onboarding"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <OnboardingPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/documentos"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <DocumentsReviewPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/renovacoes"
        element={
          <ProtectedRoute permission="emprestimos:listar">
            <DashboardLayout>
              <PipelinePage mode="renovacoes" />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/pipeline"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <PipelinePage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/leads"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <LeadsFunnelPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/auditoria"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <AuditPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/campanhas"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <CampaignsPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/campanhas/nova"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <ChargePlanWizardPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/campanhas/:id"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <ChargePlanWizardPage />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />


      {/* Gestor SaaS (Master) */}
      <Route path="/gestor/login" element={<GestorLoginPage />} />
      <Route
        path="/gestor"
        element={
          <GestorProtectedRoute>
            <GestorLayout>
              <BillingDashboardPage />
            </GestorLayout>
          </GestorProtectedRoute>
        }
      />
      <Route
        path="/gestor/tenants"
        element={
          <GestorProtectedRoute>
            <GestorLayout>
              <BillingTenantsPage />
            </GestorLayout>
          </GestorProtectedRoute>
        }
      />
      <Route
        path="/gestor/tenants/:id"
        element={
          <GestorProtectedRoute>
            <GestorLayout>
              <BillingTenantDetailPage />
            </GestorLayout>
          </GestorProtectedRoute>
        }
      />
      <Route
        path="/gestor/uso-assinaturas"
        element={
          <GestorProtectedRoute>
            <GestorLayout>
              <SignatureUsagePage />
            </GestorLayout>
          </GestorProtectedRoute>
        }
      />
      <Route
        path="/gestor/dispositivos"
        element={
          <GestorProtectedRoute>
            <GestorLayout>
              <GestorDevicesPage />
            </GestorLayout>
          </GestorProtectedRoute>
        }
      />

      {/* Redirect /dashboard/* to /dashboard */}
      <Route path="/dashboard/*" element={<Navigate to="/dashboard" replace />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/** Route guard for gestor - requires master level */
function GestorProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
      </div>
    );
  }

  if (!isAuthenticated || user?.nivel !== "master") {
    return <Navigate to="/gestor/login" replace />;
  }

  return <>{children}</>;
}

function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary-500">{t("common.not_found_title")}</h1>
        <p className="mt-4 text-xl text-muted-foreground">{t("common.not_found_message")}</p>
        <a href="/" className="mt-6 inline-block text-primary-600 hover:underline">
          {t("common.not_found_link")}
        </a>
      </div>
    </div>
  );
}

export default App;
